// Full Hermann Trucking logo (tiger + wordmark). Sized by height;
// width follows automatically to preserve the logo's natural aspect ratio.
// Background/container styling (white card, transparent, etc.) is handled
// by whichever screen uses it, not by this component itself.
function Logo({ height = 32 }) {
  return (
    <img
      src="/full-logo.png"
      alt="Hermann Trucking"
      style={{
        height: height,
        width: 'auto',
        display: 'block',
      }}
    />
  );
}

export default Logo;